<template>
  <div class="certificate-audit-container">
    <!-- 查询筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-row">
        <div class="filter-item">
          <span class="label">审核状态：</span>
          <el-select v-model="queryParams.review" placeholder="请选择审核状态" clearable style="width: 160px" @change="handleSearch">
            <el-option label="全部" :value="''"></el-option>
            <el-option label="未审核" :value="'0'"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核失败" :value="2"></el-option>
          </el-select>
        </div>
        <!-- <div class="filter-item">
          <span class="label">证件号码：</span>
          <el-input v-model="queryParams.cardNo" placeholder="请输入证件号码" clearable style="width: 200px" @clear="handleSearch" @keyup.enter="handleSearch"></el-input>
        </div> -->
        <div class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
        </div>
      </div>
    </el-card>

    <!-- 批量操作栏 -->
    <div class="batch-actions">
      <el-button type="success" :disabled="!canBatchAudit" @click="batchAudit(1)">批量通过</el-button>
      <el-button type="danger" :disabled="!canBatchAudit" @click="batchAudit(2)">批量退回</el-button>
      <span class="batch-tip" v-if="selectedRows.length > 0">已选择 {{ selectedRows.length }} 项</span>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="pagedData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
      row-key="id"
    >
      <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
      <el-table-column prop="card_no" label="证件号码" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="card_type" label="证件类型" width="100">
        <template slot-scope="scope">
          {{ scope.row.card_type === '1' ? '优待证' : '其他证件' }}
        </template>
      </el-table-column>
      <el-table-column prop="issue_unit" label="发证单位" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="service_years" label="服役年限" width="100" align="center"></el-table-column>
      <el-table-column prop="issue_time" label="发证日期" width="160"></el-table-column>
      <el-table-column label="审核状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getReviewType(scope.row.review)" size="small">
            {{ getReviewText(scope.row.review) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="证件照片" width="180" align="center">
        <template slot-scope="scope">
          <div class="image-list">
            <el-image
              v-if="scope.row.img_1"
              :src="scope.row.img_1"
              :preview-src-list="[scope.row.img_1]"
              fit="cover"
              class="thumbnail"
              :title="'正面照片'"
            ></el-image>
            <span v-else class="no-image">无正面照</span>
            <el-image
              v-if="scope.row.img_2"
              :src="scope.row.img_2"
              :preview-src-list="[scope.row.img_2]"
              fit="cover"
              class="thumbnail"
              :title="'反面照片'"
            ></el-image>
            <span v-else class="no-image">无反面照</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.review == 0">
            <el-button type="text" size="small" style="color: #67C23A" @click="singleAudit(scope.row, 1)">通过</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" @click="singleAudit(scope.row, 2)">退回</el-button>
          </template>
          <span v-else class="disabled-action">已审核</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="filteredList.length"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'
const token = Cookie.get('token')
const zjRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})
export default {
  name: 'CertificateAudit',
  data () {
    return {
      // 原始数据
      allData: [],
      // 加载状态
      loading: false,
      // 查询参数
      queryParams: {
        review: '', // 审核状态: ''全部,0未审核,1通过,2失败
        cardNo: '' // 证件号码过滤
      },
      // 表格选中项
      selectedRows: [],
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      // 接口地址基础配置
      api: {
        select: 'https://rc.rc-cloudlink.com/common/careCard.php?a=select',
        review: 'https://rc.rc-cloudlink.com/common/careCard.php?a=review'
      }
    }
  },
  computed: {
    // 前端证件号模糊过滤后的数据（基于当前查询结果）
    filteredList () {
      if (!this.queryParams.cardNo) {
        return this.allData
      }
      const keyword = this.queryParams.cardNo.trim().toLowerCase()
      return this.allData.filter(item =>
        item.card_no && item.card_no.toLowerCase().includes(keyword)
      )
    },
    // 当前分页展示的数据
    pagedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredList.slice(start, end)
    },
    // 是否可以进行批量审核（有选中项且所有选中项都是未审核状态）
    canBatchAudit () {
      if (this.selectedRows.length === 0) return false
      return this.selectedRows.every(row => row.review === 0)
    }
  },
  watch: {
    // 当筛选条件变化时，重置分页到第一页
    filteredList: {
      handler () {
        this.currentPage = 1
      },
      deep: false
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 获取审核状态文本
    getReviewText (review) {
      const map = {
        0: '未审核',
        1: '审核通过',
        2: '审核失败'
      }
      return map[review] || '未知'
    },
    // 获取审核状态标签类型
    getReviewType (review) {
      const map = {
        0: 'info',
        1: 'success',
        2: 'danger'
      }
      return map[review] || 'info'
    },
    // 表格行是否可勾选（只有未审核的才能被选中进行批量操作）
    checkSelectable (row) {
      return row.review === 0
    },
    // 处理表格选中变化
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    // 查询数据
    async loadData () {
      this.loading = true
      try {
        const params = {}
        // 如果review参数不为空字符串则传入（注意接口需要数字类型）
        if (this.queryParams.review !== '' && this.queryParams.review !== undefined) {
          params.review = this.queryParams.review
        }
        console.log(params)
        const reswww = await zjRequest.post('https://rc.rc-cloudlink.com/index/all_dian_list.php', { review: this.queryParams.review || '' })
        console.log(reswww)
        const response = await zjRequest.post(this.api.select, { ...params })
        if (response.data && response.data.code === '0') {
          this.allData = response.data.res || []
          // 重置页码到第一页
          this.currentPage = 1
        } else {
          this.$message.error(response.data?.msg || '获取数据失败')
          this.allData = []
        }
      } catch (error) {
        console.error('查询优待证列表失败:', error)
        this.$message.error('网络请求失败，请稍后重试')
        this.allData = []
      } finally {
        this.loading = false
      }
    },
    // 单个审核操作
    singleAudit (row, reviewStatus) {
      if (row.review !== '0') {
        this.$message.warning('该证件已审核，无法重复操作')
        return
      }
      const actionText = reviewStatus === 1 ? '通过' : '退回'
      this.$confirm(`确定要将证件【${row.card_no}】审核${actionText}吗？`, '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.submitReview([row.id], reviewStatus)
      }).catch(() => {})
    },
    // 批量审核操作
    batchAudit (reviewStatus) {
      if (!this.canBatchAudit) {
        this.$message.warning('请选择未审核的证件进行批量操作')
        return
      }
      const actionText = reviewStatus === 1 ? '通过' : '退回'
      const ids = this.selectedRows.map(row => row.id)
      this.$confirm(`确定要将选中的 ${ids.length} 个证件审核${actionText}吗？`, '批量操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.submitReview(ids, reviewStatus)
      }).catch(() => {})
    },
    // 通用审核提交方法
    async submitReview (ids, reviewStatus) {
      const loadingInstance = this.$loading({ text: '提交审核中...', background: 'rgba(0,0,0,0.7)' })
      try {
        const param = {
          id: ids.join(','),
          review: reviewStatus
        }
        const response = await zjRequest.post(this.api.review, param, {
          headers: { 'Content-Type': 'application/json' }
        })
        if (response.data && response.data.code === '0') {
          this.$message.success(`审核操作成功，共处理 ${ids.length} 条记录`)
          // 刷新列表
          await this.loadData()
          // 清空选中项
          this.selectedRows = []
        } else {
          this.$message.error(response.data?.msg || '审核操作失败')
        }
      } catch (error) {
        console.error('审核提交失败:', error)
        this.$message.error('网络请求失败，请检查网络后重试')
      } finally {
        loadingInstance.close()
      }
    },
    // 查询按钮点击
    handleSearch () {
      this.currentPage = 1
      this.loadData()
    },
    // 重置筛选条件
    handleReset () {
      this.queryParams = {
        review: '',
        cardNo: ''
      }
      this.currentPage = 1
      this.loadData()
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style lang="scss" scoped>
.certificate-audit-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  overflow:auto;
  box-sizing: border-box;

  .filter-card {
    margin-bottom: 20px;
    border-radius: 8px;

    .filter-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 16px;

      .filter-item {
        display: flex;
        align-items: center;
        .label {
          margin-right: 8px;
          color: #606266;
          font-size: 14px;
        }
      }

      .filter-actions {
        margin-left: auto;
      }
    }
  }

  .batch-actions {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    .batch-tip {
      margin-left: 12px;
      color: #909399;
      font-size: 13px;
    }
  }

  .image-list {
    display: flex;
    justify-content: center;
    gap: 8px;
    .thumbnail {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      border: 1px solid #e4e7ed;
      cursor: pointer;
      transition: transform 0.2s;
      &:hover {
        transform: scale(1.05);
      }
    }
    .no-image {
      font-size: 12px;
      color: #c0c4cc;
    }
  }

  .disabled-action {
    color: #c0c4cc;
    font-size: 12px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
    background-color: #fff;
    padding: 12px 16px;
    border-radius: 4px;
  }
}
</style>
